import { EXERCISE_CLASS_NAME } from '../../../exercise'

import getClassNameReduxUtil from '../../utils/get-class-name'
import { shouldKeepExerciseHook } from '../../../exercise/model/hooks'

const CLASS_NAME_TO_FUNCTION = {
  [EXERCISE_CLASS_NAME]: shouldKeepExerciseHook
}

function shouldKeepReduxHook (instance, state) {
  const className = getClassNameReduxUtil(instance)
  const fn = CLASS_NAME_TO_FUNCTION[className]
  if (!fn) {
    return false
  }
  return fn(instance, state)
}

export { shouldKeepReduxHook }
